<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <h3>派单统计</h3>
      </div>
      <plt-table ref="tableRef" :url="queryUrl" :queryParams="queryParams" :pageSize="10">
        <el-table-column label="派单日期" prop="pushDate" />
        <el-table-column label="数量" prop="pushQty" />
      </plt-table>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "carrierQueriesPushCounting",
  data() {
    return {
      queryUrl: "http://MID-OPERATE-LOGISTICS/messageService/carrierProxyQueryService/carrierQueriesPushCounting",
      queryParams: {
        memberId: sessionStorage.getItem("memberId")
      }
    };
  }
};
</script>